module.exports = __webpack_public_path__ + "img/hotel-gray.8c2859c8.png";